(function () {
  // Only run on the homepage
  if (!document.body.classList.contains('template-index')) return;

  function findSectionByText(regex) {
    var candidates = document.querySelectorAll('body *');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.children.length === 0 && el.textContent && regex.test(el.textContent)) {
        var section = el.closest('.shopify-section');
        if (section) return section;
      }
    }
    return null;
  }

  function fixSocialIcons() {
    var section = findSectionByText(/check\s*out\s*our\s*socials/i);
    if (!section) return;
    // Find the icon links inside this section and center/align them as a row
    var links = section.querySelectorAll('a[href*="facebook"], a[href*="instagram"], a[href*="twitter"], a[href*="tiktok"]');
    if (!links.length) return;
    var parent = links[0].parentElement;
    if (parent) {
      parent.style.display = 'flex';
      parent.style.justifyContent = 'center';
      parent.style.alignItems = 'center';
      parent.style.gap = '16px';
      parent.style.flexWrap = 'wrap';
    }
  }

  function fixNewsletterForm() {
    var section = findSectionByText(/don.?t\s*miss\s*out|freshest\s*flavou?rs|subscribe/i);
    if (!section) return;
    var form = section.querySelector('form');
    if (!form) return;
    form.style.display = 'flex';
    form.style.flexWrap = 'wrap';
    form.style.justifyContent = 'center';
    form.style.alignItems = 'center';
    form.style.gap = '12px';
    form.style.maxWidth = '500px';
    form.style.margin = '0 auto';
  }

  function init() {
    fixSocialIcons();
    fixNewsletterForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
